import React from 'react';

interface FloorBlock {
  floor: string;
  department: string;
  utilization: number;
  capacity: number;
  sqft: number;
}

interface BuildingStackProps {
  floors: FloorBlock[];
  width?: number;
  height?: number;
}

const BuildingStack: React.FC<BuildingStackProps> = ({
  floors,
  width = 400,
  height = 500
}) => {
  const floorHeight = height / floors.length;

  const getUtilizationColor = (utilization: number) => {
    if (utilization < 25) return '#F9F7F2';
    if (utilization < 40) return '#0A9B9B22';
    if (utilization < 55) return '#0A9B9B44';
    if (utilization < 70) return '#0A9B9B66';
    return '#0A9B9B88';
  };

  return (
    <svg width={width} height={height} style={{ backgroundColor: '#F9F7F2' }}>
      {floors.map((floor, index) => {
        const y = index * floorHeight;
        const fillColor = getUtilizationColor(floor.utilization);

        return (
          <g key={floor.floor}>
            <rect
              x={0}
              y={y}
              width={width}
              height={floorHeight}
              fill={fillColor}
              stroke="#1a1a1a"
              strokeWidth={1}
            />

            <text
              x={10}
              y={y + 20}
              style={{
                fontSize: '14px',
                fontWeight: '600',
                fill: '#1a1a1a'
              }}
            >
              {floor.floor}
            </text>

            <text
              x={10}
              y={y + 38}
              style={{
                fontSize: '12px',
                fill: '#666'
              }}
            >
              {floor.department}
            </text>

            <text
              x={width - 10}
              y={y + 28}
              textAnchor="end"
              style={{
                fontSize: '16px',
                fontWeight: '600',
                fill: floor.utilization < 40 ? '#c33' : '#0A9B9B'
              }}
            >
              {floor.utilization}%
            </text>

            <text
              x={width - 10}
              y={y + 46}
              textAnchor="end"
              style={{
                fontSize: '10px',
                fill: '#999'
              }}
            >
              {floor.sqft.toLocaleString()} sq ft
            </text>
          </g>
        );
      })}
    </svg>
  );
};

export default BuildingStack;
